import { env } from '../lib/env';

export type SourceMarket = {
  id: string;
  code: string;
  slug: string;
  name: string;
  subtitle?: string | null;
  flagCode?: string | null;
  sortOrder?: number;
  isActive?: boolean;
  productCount?: number;
};

export async function fetchSourceMarkets(): Promise<SourceMarket[]> {
  const response = await fetch(`${env.API_URL}/api/products/source-markets`);

  if (!response.ok) {
    throw new Error('Failed to fetch source markets');
  }

  const data = (await response.json()) as SourceMarket[];

  return Array.isArray(data) ? data : [];
}
